module.exports = __webpack_public_path__ + "img/v_logo.faec1416.png";